// action types
import { createRequestTypes } from "../../utils";

export const FETCH_CATEGORIES = createRequestTypes("FETCH_CATEGORIES");

export const fetchCategoriesRequest = () =>
    ({ type: FETCH_CATEGORIES.REQUEST });

export const fetchCategoriesSuccess = (categories) =>
    ({ type: FETCH_CATEGORIES.SUCCESS, payload: categories });

export const fetchCategoriesFailure = (error) =>
    ({ type: FETCH_CATEGORIES.FAILURE, payload: error });